import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import InstallBanner from "@/components/pwa/InstallBanner";

export default function PublicLayout() {
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <InstallBanner />
        </div>
    );
}
